import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import InfoSignatureStep1Bloc from "../blocs/info-signature/InfoSignatureStep1Bloc";

export default function InfoSignatureStep1Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);
    return (
     
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Signature du contrat</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
            <InfoSignatureStep1Bloc />
        </div>
      </div>
  
    )

}